import { Badge } from "@/components/ui/badge";
import type { Word } from "@/types/word";

interface WordCardProps {
  word: Word;
}

export const WordCard = ({ word }: WordCardProps) => {
  return (
    <div className="p-6 rounded-3xl bg-card border border-border hover:border-primary/50 transition-all hover:shadow-lg">
  <Badge variant="outline" className="w-fit text-sm rounded-full mb-4 py-2 px-3">
        {word.category}
      </Badge>
      <h3 className="text-2xl font-bold mb-3">{word.word}</h3>
      <p className="text-muted-foreground leading-relaxed">{word.definition}</p>

    </div>
  );
};
